import { Img } from "container/Manual/components/content/Image";
import { PageLink } from "container/Manual/components/content/PageLink";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";
import { TextSection } from "container/Manual/components/section/TextSection";

export const REGEXP = () => {
  return (
    <CardSection id="REGEXP" title="REGEXP">
      <Paragraph>
        정규 표현식(regex)과 일치하는 <b>모든</b> 문자열에 대한 검색 및 치환
        작업을 수행합니다. 이 함수는 Java의 정규 표현식(Java Regex)을 기반으로
        동작합니다.
      </Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>REGEXP(STRING_1, STRING_2, STRING_3)</Paragraph>
        <Ul>
          <Li>
            <b>STRING_1</b>은 검색 및 치환 대상이 되는 원본 문자열입니다.
          </Li>
          <Li>
            <b>STRING_2</b>는 <b>STRING_1</b>에서 찾고자 하는 정규 표현식
            패턴입니다.
          </Li>
          <Li>
            <b>STRING_3</b>은 <b>STRING_2</b> 패턴에 일치하는 부분을 대체할
            문자열입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>REGEXP(`product`, "a", "!")</Paragraph>
        <Img src="computeRegExp" />
      </ListSection>

      <ListSection title="Notes on use">
        <TextSection>
          <b>REGEXP</b> 함수는 텍스트 열 또는 표현식, 검색할{" "}
          <PageLink
            label="정규 표현식"
            url="https://en.wikipedia.org/wiki/Regular_expression"
          />
          , 찾은 항목을 대체할 값의 세 가지 인수를 받습니다.
          <b>STRING_1</b>은 텍스트 문자열, 텍스트 문자열이 포함된 열 또는 텍스트
          문자열을 반환하는 함수여야 합니다. <b>STRING_2</b>와 <b>STRING_3</b>은
          검색 및 바꾸기를 정의하는 문자 조합으로 구성됩니다.
        </TextSection>

        <TextSection>
          정규 표현식에는 특수 의미를 가진 문자가 있습니다. (
          <b>^ $ . | ? * + ( ) [</b> 및 열린 중괄호)
          <br />
          특수 의미가 아닌 실제 문자를 검색하려면 앞에 <b>백슬래시 두 개</b>를
          추가합니다. 예를 들어 정규 표현식으로 별표 문자를 검색하려면 "{" "}
          <b>*</b> "가 아닌 " <b>\\*</b> "를 입력합니다. 정규 표현식으로
          백슬래시 문자를 검색하려면 백슬래시 문자를 네 개 입력합니다.
        </TextSection>

        <TextSection>
          정규 표현식 패턴 일치에 대한 자세한 지침은 다음을 참조하세요.
          <br />
          <PageLink
            label="https://docs.oracle.com/javase/8/docs/api/java/util/regex/Pattern.html"
            url="https://docs.oracle.com/javase/8/docs/api/java/util/regex/Pattern.html"
          />
        </TextSection>

        <TextSection>
          <b>예제</b>
          <br />
          텍스트 <b>ABC</b>를 <b>DEF</b>로 바꾸려면:
          <br />
          <Paragraph accent>REGEXP(`ProductID` , "ABC", "DEF")</Paragraph>
          <br />
          공백 문자를 하이픈으로 변환하려면:
          <br />
          <Paragraph accent>REGEXP(`ProductID` , " ", "-")</Paragraph>
          <br />
          별표(특수 문자)를 하이픈으로 변환하려면:
          <br />
          <Paragraph accent>REGEXP(`ProductID` , "\\*", "-")</Paragraph>
          <br />
          백슬래시(특수 문자)를 하이픈으로 변환하려면:
          <br />
          <Paragraph accent>REGEXP(`ProductID` , "\\\\", "-")</Paragraph>
        </TextSection>
      </ListSection>
    </CardSection>
  );
};
